/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: LUEYaWE5GnZw
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonNav2 from "../../ButtonNav2"; // plasmic-import: ep0w6NE2omrP/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicSectionFooter.module.css"; // plasmic-import: LUEYaWE5GnZw/css
import image2JBmR49O2CvwD from "./images/image2.svg"; // plasmic-import: JBmR49O2CvwD/picture

createPlasmicElementProxy;

export const PlasmicSectionFooter__VariantProps = new Array("layout");

export const PlasmicSectionFooter__ArgProps = new Array("sectionId");

const $$ = {};

function PlasmicSectionFooter__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layout",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layout
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <section
      data-plasmic-name={"footer"}
      data-plasmic-override={overrides.footer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.footer,
        {
          [sty.footerlayout_full]: hasVariant($state, "layout", "full"),
          [sty.footerlayout_withOffset]: hasVariant(
            $state,
            "layout",
            "withOffset"
          )
        }
      )}
      id={(() => {
        try {
          return $props.sectionId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"contentWrapper2"}
        data-plasmic-override={overrides.contentWrapper2}
        className={classNames(projectcss.all, sty.contentWrapper2)}
      >
        <div
          data-plasmic-name={"leftColumn2"}
          data-plasmic-override={overrides.leftColumn2}
          className={classNames(projectcss.all, sty.leftColumn2)}
        >
          <div className={classNames(projectcss.all, sty.freeBox___0AbhT)}>
            <div className={classNames(projectcss.all, sty.freeBox___0NCsT)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hFu6F
                )}
              >
                {"o21p"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fTiD7
                )}
              >
                {"/"}
              </div>
              <ButtonNav2
                data-plasmic-name={"buttonNav2"}
                data-plasmic-override={overrides.buttonNav2}
                className={classNames("__wab_instance", sty.buttonNav2)}
                color={"white"}
                iconForButton={
                  <PlasmicImg__
                    data-plasmic-name={"img"}
                    data-plasmic-override={overrides.img}
                    alt={""}
                    className={classNames(sty.img)}
                    displayHeight={"100%"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"none"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: image2JBmR49O2CvwD,
                      fullWidth: 256,
                      fullHeight: 256,
                      aspectRatio: 1
                    }}
                  />
                }
                onClick={async () => {
                  const $steps = {};
                  $steps["goToHttpsO21PCom"] = true
                    ? (() => {
                        const actionArgs = { destination: "https://o21p.com/" };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToHttpsO21PCom"] != null &&
                    typeof $steps["goToHttpsO21PCom"] === "object" &&
                    typeof $steps["goToHttpsO21PCom"].then === "function"
                  ) {
                    $steps["goToHttpsO21PCom"] =
                      await $steps["goToHttpsO21PCom"];
                  }
                }}
                shape={"fullRounding"}
                slotSize={"fillButton"}
                status={"normal"}
              />
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__fM0Gz
              )}
            >
              {
                "\u00a92025 o21p - all rights reserved.\nBuilt and backed by haaaven, SRL."
              }
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"rightColumn2"}
          data-plasmic-override={overrides.rightColumn2}
          className={classNames(projectcss.all, sty.rightColumn2)}
        >
          <div className={classNames(projectcss.all, sty.freeBox___1PwCq)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__b8LHf
              )}
            >
              {"COMPANY."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__ql9Zh
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__yt8X9,
                      {
                        [sty.linklayout_full__yt8X9P9LdO]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://team.o21p.com/cause"}
                    platform={"react"}
                  >
                    {"cause"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dEmeW
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__jJnjn,
                      {
                        [sty.linklayout_full__jJnjnP9LdO]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://partner.o21p.com/mission"}
                    platform={"react"}
                  >
                    {"mission"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__i1FmS
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__buPuY
                    )}
                    href={"https://opformypractice.com/legal"}
                    platform={"react"}
                  >
                    {"legal"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__az9X)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__pyv97
              )}
            >
              {"WEBSITES."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__bxkUj
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__uoXf,
                      {
                        [sty.linklayout_full__uoXfp9LdO]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://partner.o21p.com/"}
                    platform={"react"}
                  >
                    {"partner"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__mYq32
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__g7Ssd,
                      {
                        [sty.linklayout_full__g7Ssdp9LdO]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://team.o21p.com/"}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__rxW0T
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__rt9Oa,
                      {
                        [sty.linklayout_full__rt9OaP9LdO]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://nexus.o21p.com/"}
                    platform={"react"}
                  >
                    {"nexus"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dmfed
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__a0Wo
                    )}
                    href={"https://opformypractice.com/legal"}
                    platform={"react"}
                  >
                    {"legal"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__obL3V)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__so7
              )}
            >
              {"CONTACT."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__oyvDv
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__uxamv,
                      {
                        [sty.linklayout_full__uxamvP9LdO]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        ),
                        [sty.linklayout_withOffset__uxamvNzVxs]: hasVariant(
                          $state,
                          "layout",
                          "withOffset"
                        )
                      }
                    )}
                    href={"https://o21p.com/support"}
                    platform={"react"}
                  >
                    {"support"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___80Ag5,
                {
                  [sty.textlayout_full___80Ag5P9LdO]: hasVariant(
                    $state,
                    "layout",
                    "full"
                  )
                }
              )}
            >
              {"cristian@o21p.com"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const PlasmicDescendants = {
  footer: [
    "footer",
    "contentWrapper2",
    "leftColumn2",
    "buttonNav2",
    "img",
    "rightColumn2"
  ],

  contentWrapper2: [
    "contentWrapper2",
    "leftColumn2",
    "buttonNav2",
    "img",
    "rightColumn2"
  ],

  leftColumn2: ["leftColumn2", "buttonNav2", "img"],
  buttonNav2: ["buttonNav2", "img"],
  img: ["img"],
  rightColumn2: ["rightColumn2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionFooter__ArgProps,
          internalVariantPropNames: PlasmicSectionFooter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footer") {
    func.displayName = "PlasmicSectionFooter";
  } else {
    func.displayName = `PlasmicSectionFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionFooter = Object.assign(
  // Top-level PlasmicSectionFooter renders the root element
  makeNodeComponent("footer"),
  {
    // Helper components rendering sub-elements
    contentWrapper2: makeNodeComponent("contentWrapper2"),
    leftColumn2: makeNodeComponent("leftColumn2"),
    buttonNav2: makeNodeComponent("buttonNav2"),
    img: makeNodeComponent("img"),
    rightColumn2: makeNodeComponent("rightColumn2"),
    // Metadata about props expected for PlasmicSectionFooter
    internalVariantProps: PlasmicSectionFooter__VariantProps,
    internalArgProps: PlasmicSectionFooter__ArgProps
  }
);

export default PlasmicSectionFooter;
/* prettier-ignore-end */
